import React, { useEffect,useState } from 'react'
import _ from 'lodash';
import { useNavigate, useParams } from 'react-router-dom';
import * as R from 'ramda';
import { useAppDispatch, useAppSelector } from '../../../../../hooks/hooks';
import { selectCurrent } from '../../../../../redux/settings/selectors';
import { useSelector } from 'react-redux';
import { selectHelpTopicsCreatedItem, selectHelpTopicsListItems, selectHelpTopicsQueryItem } from '../../../../../redux/help-topics/selector';
import { selectHelpTopicsFilesQueryItem } from '../../../../../redux/help-topics-files/selector';
import { deepCopy } from '../../../../../common/services/common.service';
import { helpTopics } from '../../../../../redux/help-topics/action';
import { settings } from '../../../../../redux/settings/actions';
import UploadFiles from '../../../../../models/UploadFile';
import PageLoader from '../../../../../components/PageLoader';
import HelpTopicComponent from '../components/help-topic.component';
import { helpTopicsFiles } from '../../../../../redux/help-topics-files/action';

let currentChange: any = {}
const ManagementHelpTopic= () => {  
  const navigate = useNavigate()
  const dispatch = useAppDispatch()
  const parmas: any = useParams()
  const { getUploadFiles } = useAppSelector(selectCurrent)
  const [isLoading, setIsLoading] = useState<boolean>(true)
  const queryItems = useSelector(selectHelpTopicsQueryItem)
  const helpTopicsItems = useSelector(selectHelpTopicsListItems)
  const HelpTopicFilequeryItems = useSelector(selectHelpTopicsFilesQueryItem)
  const helpTopicsCreateItems  = useSelector(selectHelpTopicsCreatedItem)
  const [data, setData] = useState<boolean>(false)
const [isQuery, setIsQuery] = useState<boolean>(false)
const [
    selectedHelpTopics,
    setSelectedHelpTopics
  ] = useState<any>({})
  const [
    HelpTopicsImageIndex,
    setHelpTopicsImageIndex
  ] = useState<any>([])

  const [
    mediaFiles,
    setMediaFiles
  ] = useState<any>([])
  const [
    openFile,
    setOpenFile
  ] = useState<any>([]);
 
  const handleFormItemChange: any = ({ value, field, idx }: any) => {
    const items = deepCopy(mediaFiles);// deep copy of grn items
    let item = items[idx];// deep copy of item to be edited
    item = { ...item, [field]: value }// updated the particular item
    items[idx] = item;
    currentChange = { value, field, idx }
    setMediaFiles(items);
  }


  const fetchhelpTopicFilesById= ()=>{
    dispatch(helpTopics.query({url:`https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/cms/help-topics/query`,entity:'helpTopics',jsonData:{
          
    Records: [
      {
        
          
              "Id": parmas?.id
          
      
       
      }
    ]
  
}})).then(()=>{
    dispatch(helpTopicsFiles.query({url:`https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/cms/help-topic-documents/query-by-help-topic`,entity:'helpTopicFiles',jsonData:{
          
        Records: [
          {
            
              
                  "Id": parmas?.id
              
          
           
          }
        ]
      
    }}))}).then(()=>{

  setIsQuery(true)
})




  }

  const handleInnerFormChange: any = (event: any, field: string) => {
    setSelectedHelpTopics({ ...selectedHelpTopics, [field]: event });
  }

  useEffect(
  
    () => {
      dispatch(helpTopics.list({url:`https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/cms/help-topics/list`,entity:'helpTopics',jsonData:{
      }}))
      if (parmas?.id > 0) {
        fetchhelpTopicFilesById()
        setIsLoading(false)
    }else {
        const localSelectedMedia = addNewMediaFilesRow({ selectedMediaFilesArg: mediaFiles });
        setMediaFiles(localSelectedMedia)
        setIsLoading(false)
      }
    },
    []
  )

  useEffect(
    () => {
        
      if (data) {
        if(parmas?.id >0){
                  mediaFiles?.splice(
                mediaFiles.length - 1,
                  1
                )
                if(mediaFiles.length>0){
                  const helpTopicFileData: any = mediaFiles?.map((item: any) => {
                    const itemData = {
                      Id: item?.Id,
                      HelpTopicId: parmas?.id,
                      FileTypeId: item?.FileTypeId,
                      HelpTopicDocumentUrl: item?.FileMappingURL
                      }
                    
                    return itemData
                  })
                  dispatch(helpTopicsFiles.update({url:`https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/cms/help-topic-documents`,entity:'helpTopicFiles',jsonData:{
          
                    Records: 
                      
                        
                       
                         helpTopicFileData
                        
                    
                     
                    
                      
                    
                 
                }}))            
              back()
           }
          }
          else{
            mediaFiles?.splice(
              mediaFiles.length - 1,
                1
              )
              if(mediaFiles.length>0){
                const helpTopicFileData: any = mediaFiles?.map((item: any) => {
                  const itemData = {
                    Id: item?.Id,
                    HelpTopicId: helpTopicsCreateItems?.result[0],
                    FileTypeId: item?.FileTypeId,
                    HelpTopicDocumentUrl: item?.FileMappingURL
                    }
                  
                  return itemData
                })
                dispatch(helpTopicsFiles.create({url:`https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/cms/help-topic-documents`,entity:'helpTopicFiles',jsonData:{
                  
                Records: 
                  
                    
                  
                  helpTopicFileData
                    
                
                
                
                  
                
            
            }}))}
            back()
           }
         }
       
    },

    [data]
  )
  useEffect(
    () => {
        
      if (isQuery) {
        setSelectedHelpTopics(queryItems?.result?.items)
        const helpTopicItemsData: any = HelpTopicFilequeryItems?.result?.items?.map((item: any) => {
            const itemData = {
              Id: item?.Id,
              HelpTopicId: item?.HelpTopicId,
              FileTypeId: item?.FileTypeId,
              FileMappingURL: item?.HelpTopicDocumentUrl
            }
            return itemData
          })
          if(helpTopicItemsData){
        const localSelectedMedia = addNewMediaFilesRow({ selectedMediaFilesArg: helpTopicItemsData });
        setMediaFiles(localSelectedMedia)
      }}
    },
    [isQuery]
  )
 
  const deleteSelectedFile = async (Item: any, index: any) => {
    if (Item.Id === 0) {
      mediaFiles?.splice(
        index,
        1
      )
    }
    else {
        dispatch(helpTopicsFiles.update({url:`https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/cms/help-topic-documents/delete`,entity:'helpTopicFiles',jsonData:{
        }})).then(()=>{
      mediaFiles?.splice(
        index,
        1
      )
        })}
  }

  const getIsImageRecordDeletable = (idx: any) => {
    if (mediaFiles.length - 1 === idx) {
      return false
    }
    return true
  }

const handleFormSubmit  = async (event: any) => {

    event.preventDefault();
    if (parmas?.id > 0) {
     dispatch(helpTopics.update({url:`https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/cms/help-topics`,entity:'helpTopics',jsonData:{
          
    Records: [
      
      
       
         selectedHelpTopics
        
    
     
    
      
    ]
 
}})).then(()=>{
  
  setData(true)

})

    }else{
        dispatch(helpTopics.create({url:`https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/cms/help-topics`,entity:'helpTopics',jsonData:{
          
            Records: [
              
                
               
                 selectedHelpTopics
                
            
             
            
              
            ]
    
  }})).then(()=>{
    setData(true)
  })
    }

  }

const back=()=>{
  navigate('/management/cms/help-topics')
} 
const addNewMediaFilesRow = ({ selectedMediaFilesArg }: any) => {
    const localSelectedmedia = deepCopy(selectedMediaFilesArg)
    const newsSelectedMedia = {
        Id: 0,
        HelpTopicId: parmas?.id,
        FileTypeId: 0,
        FileMappingURL: ''
    }
    if (localSelectedmedia.length === 0 ||
      localSelectedmedia[localSelectedmedia?.length - 1]?.FileTypeId !== 0
    ) {
      localSelectedmedia?.push(newsSelectedMedia)
    }
  
    return localSelectedmedia
  }
  const setCombinationInfo = async () => {
    let localSelectedMedia = deepCopy(mediaFiles)
    localSelectedMedia.splice(
      currentChange.idx,
      1,
      { ...localSelectedMedia[currentChange.idx] }
    );
    localSelectedMedia = addNewMediaFilesRow({ selectedMediaFilesArg: localSelectedMedia });
    currentChange.field = 'FileTypeIdDONE'
    setMediaFiles(localSelectedMedia)
  }
  const changeImage = (idx: number, templateField: any, fileType: any) => {
    setHelpTopicsImageIndex(idx)
    dispatch(settings.set({ getUploadFiles: 'open' }))
    setOpenFile({
      currentFileSrc: mediaFiles[idx][templateField],
      folder: 'Topic',
      type: fileType
    })
  }
  const handleSubmit = (data: any) => {
  
    mediaFiles[HelpTopicsImageIndex].FileMappingURL = data
    const localSelectedMedia = addNewMediaFilesRow({ selectedMediaFilesArg: mediaFiles });
    setMediaFiles(localSelectedMedia)
  }
  const handleClose = () => {
    dispatch(settings.set({ getUploadFiles: 'close' }))
    
  }
  
  useEffect(
    () => {
      if (currentChange.field === 'FileTypeId') {
        setCombinationInfo()
      }
    },
    [mediaFiles]
  )

    return (
    <>
     {getUploadFiles == 'open' && <UploadFiles  currentFilesSrc={openFile?.currentFileSrc}
    folder={openFile?.folder}
         handleClose={handleClose}
         handleFilesSubmit={handleSubmit}
         type={openFile?.type}
         />}
    {isLoading ? <PageLoader /> : 
          <HelpTopicComponent
          handleInnerFormChange={handleInnerFormChange}
          handleFormSubmit={handleFormSubmit}
          back={back}
          selectedHelpTopics={selectedHelpTopics}
          mediaFiles={mediaFiles}
          handleFormItemChange={handleFormItemChange}
          changeImage={changeImage}
          getIsImageRecordDeletable={getIsImageRecordDeletable}
          deleteSelectedFile={deleteSelectedFile}
          helpTopics={helpTopicsItems?.result?.items}
          />
        }
    
          </>
    )
    
    }
   
    export default ManagementHelpTopic;
